const state = {
    showReducedRows: true,
    samples: {}
};

const getters = {
    getShowReducedRows(state) {
        return state.showReducedRows;
    },
    getSamples(state) {
        return state.samples;
    }
};

const mutations = {
    switchShowReducedRowsButton(state) {
        state.showReducedRows = !state.showReducedRows;
    },
    setSamples(state, samples) {
        state.samples = samples
    }
};

const actions = {};

export default {
    state,
    getters,
    mutations,
    actions
}
